import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SurveysComponent } from './surveys/surveys.component';
import { RecapsComponent } from './recaps/recaps.component';
import { SingleRecapViewerComponent } from './single-recap-viewer/single-recap-viewer.component';
import { AuthGuard } from './auth/auth.guard';
import { GameListComponent } from './game-list/game-list.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ReportsComponent } from './reports/reports.component';
import { WrongAnswerComponent } from './wrong-answer/wrong-answer.component';
// import { HistoricalDataComponent } from './historical-data/historical-data.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthComponent } from './auth/auth.component';
import { PlayersByVenueReportComponent } from './players-by-venue-report/players-by-venue-report.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { RedisKeysComponent } from './redis-keys/redis-keys.component';
import { InactiveWorkersReportComponent } from './inactive-workers-report/inactive-workers-report.component';
import { EmployeeComponent } from './employee/employee.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeeCreateComponent } from './employee-create/employee-create.component';
import { ClientComponent } from './client/client.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { ClientCreateComponent } from './client-create/client-create.component';
import { VenueComponent } from './venue/venue.component';
import { VenueDetailsComponent } from './venue-details/venue-details.component';
import { VenueCreateComponent } from './venue-create/venue-create.component';
import { VenuesLowScratchPaperComponent } from './venues-low-scratch-paper/venues-low-scratch-paper.component';
import { LeaguesComponent } from './leagues/leagues.component';
import { NewLeagueComponent } from './new-league/new-league.component';
import { VenuesHistoricalCancellationsComponent } from './venues-historical-cancellations/venues-historical-cancellations.component';
import { VenueHealthComponent } from './venue-health/venue-health.component';
import { NumberGeneratorComponent } from './number-generator/number-generator.component';
import { HostStatsReportComponent } from './host-stats-report/host-stats-report.component';

const routes: Routes = [
	{ path: "auth", component: AuthComponent },
	{ path: "forgot-password", component: ForgotPasswordComponent },
	{ path: "new-password/:token", component: NewPasswordComponent },
	{ path: 'surveys', component: SurveysComponent, canActivate: [AuthGuard] },
	{ path: 'leagues', component: LeaguesComponent, canActivate: [AuthGuard] },
	{ path: 'leagues/new', component: NewLeagueComponent, canActivate: [AuthGuard] },
	{ path: 'notifications', component: NotificationsComponent, canActivate: [AuthGuard] },
	{ path: 'games/list', component: GameListComponent, canActivate: [AuthGuard] },
	{ path: 'recaps/:gameid', component: SingleRecapViewerComponent, canActivate: [AuthGuard] },
	{ path: 'recaps', component: RecapsComponent, canActivate: [AuthGuard] },
	{ path: 'employees', component: EmployeeComponent, canActivate: [AuthGuard] },
	{ path: 'employees/new', component: EmployeeCreateComponent, canActivate: [AuthGuard] },
	{ path: 'employees/:employee_id/details', component: EmployeeDetailsComponent, canActivate: [AuthGuard] },
	{ path: 'clients', component: ClientComponent, canActivate: [AuthGuard] },
	{ path: 'clients/new', component: ClientCreateComponent, canActivate: [AuthGuard] },
	{ path: 'clients/:client_id/details', component: ClientDetailsComponent, canActivate: [AuthGuard] },
	{ path: 'venues', component: VenueComponent, canActivate: [AuthGuard] },
	{ path: 'venues/new', component: VenueCreateComponent, canActivate: [AuthGuard] },
	{ path: 'venues/:venue_id/details', component: VenueDetailsComponent, canActivate: [AuthGuard] },
	{
		path: "reports",
		component: ReportsComponent,
		children: [
			{
				path: "content/wrong-answer/:setid",
				component: WrongAnswerComponent
			},
			{
				path: "content/wrong-answer",
				component: WrongAnswerComponent
			},
			{
				path: "venues/player-report",
				component: PlayersByVenueReportComponent
			},
        	{
				path: "workers/inactive-report",
				component: InactiveWorkersReportComponent
			},
			{
				path: "venues/scratch-paper",
				component: VenuesLowScratchPaperComponent
			},
			{
				path: "venues/historical-cancellations",
				component: VenuesHistoricalCancellationsComponent
			},
			{
				path: "venues/health-report",
				component: VenueHealthComponent
			},
      {
				path: "workers/inactive-report",
				component: InactiveWorkersReportComponent
      },
      {
				path: "workers/user-stats-report",
				component: HostStatsReportComponent
      },
      {
        path: "venues/scratch-paper",
        component: VenuesLowScratchPaperComponent
      }
		], canActivate: [AuthGuard]
	},
    {path: 'redis-keys', component: RedisKeysComponent, canActivate: [AuthGuard]},
    {path: 'number-generator', component: NumberGeneratorComponent, canActivate: [AuthGuard]},
    {path: 'redis-keys', component: RedisKeysComponent, canActivate: [AuthGuard]},
	{ path: "", component: DashboardComponent, canActivate: [AuthGuard] }
	// {
	// 	path: 'historical-data', component: HistoricalDataComponent, canActivate: [AuthGuard]
	// }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
